/* Form options - populate country/phone selects dynamically to keep HTML lean */
const PHONE_CODES = [
  ["+1", "US +1"],
  ["+49", "DE +49"],
  ["+247", "AC +247"],
  ["+376", "AD +376"],
  ["+971", "AE +971"],
  ["+93", "AF +93"],
  ["+1", "AG +1"],
  ["+1", "AI +1"],
  ["+355", "AL +355"],
  ["+374", "AM +374"],
  ["+244", "AO +244"],
  ["+54", "AR +54"],
  ["+1", "AS +1"],
  ["+43", "AT +43"],
  ["+61", "AU +61"],
  ["+297", "AW +297"],
  ["+358", "AX +358"],
  ["+994", "AZ +994"],
  ["+387", "BA +387"],
  ["+1", "BB +1"],
  ["+880", "BD +880"],
  ["+32", "BE +32"],
  ["+226", "BF +226"],
  ["+359", "BG +359"],
  ["+973", "BH +973"],
  ["+257", "BI +257"],
  ["+229", "BJ +229"],
  ["+590", "BL +590"],
  ["+1", "BM +1"],
  ["+673", "BN +673"],
  ["+591", "BO +591"],
  ["+599", "BQ +599"],
  ["+55", "BR +55"],
  ["+1", "BS +1"],
  ["+975", "BT +975"],
  ["+267", "BW +267"],
  ["+375", "BY +375"],
  ["+501", "BZ +501"],
  ["+1", "CA +1"],
  ["+61", "CC +61"],
  ["+243", "CD +243"],
  ["+236", "CF +236"],
  ["+242", "CG +242"],
  ["+41", "CH +41"],
  ["+225", "CI +225"],
  ["+682", "CK +682"],
  ["+56", "CL +56"],
  ["+237", "CM +237"],
  ["+86", "CN +86"],
  ["+57", "CO +57"],
  ["+506", "CR +506"],
  ["+53", "CU +53"],
  ["+238", "CV +238"],
  ["+599", "CW +599"],
  ["+61", "CX +61"],
  ["+357", "CY +357"],
  ["+420", "CZ +420"],
  ["+49", "DE +49"],
  ["+253", "DJ +253"],
  ["+45", "DK +45"],
  ["+1", "DM +1"],
  ["+1", "DO +1"],
  ["+213", "DZ +213"],
  ["+593", "EC +593"],
  ["+372", "EE +372"],
  ["+20", "EG +20"],
  ["+212", "EH +212"],
  ["+291", "ER +291"],
  ["+34", "ES +34"],
  ["+251", "ET +251"],
  ["+358", "FI +358"],
  ["+679", "FJ +679"],
  ["+500", "FK +500"],
  ["+691", "FM +691"],
  ["+298", "FO +298"],
  ["+33", "FR +33"],
  ["+241", "GA +241"],
  ["+44", "GB +44"],
  ["+1", "GD +1"],
  ["+995", "GE +995"],
  ["+594", "GF +594"],
  ["+44", "GG +44"],
  ["+233", "GH +233"],
  ["+350", "GI +350"],
  ["+299", "GL +299"],
  ["+220", "GM +220"],
  ["+224", "GN +224"],
  ["+590", "GP +590"],
  ["+240", "GQ +240"],
  ["+30", "GR +30"],
  ["+502", "GT +502"],
  ["+1", "GU +1"],
  ["+245", "GW +245"],
  ["+592", "GY +592"],
  ["+852", "HK +852"],
  ["+504", "HN +504"],
  ["+385", "HR +385"],
  ["+509", "HT +509"],
  ["+36", "HU +36"],
  ["+62", "ID +62"],
  ["+353", "IE +353"],
  ["+972", "IL +972"],
  ["+44", "IM +44"],
  ["+91", "IN +91"],
  ["+246", "IO +246"],
  ["+964", "IQ +964"],
  ["+98", "IR +98"],
  ["+354", "IS +354"],
  ["+39", "IT +39"],
  ["+44", "JE +44"],
  ["+1", "JM +1"],
  ["+962", "JO +962"],
  ["+81", "JP +81"],
  ["+254", "KE +254"],
  ["+996", "KG +996"],
  ["+855", "KH +855"],
  ["+686", "KI +686"],
  ["+269", "KM +269"],
  ["+1", "KN +1"],
  ["+850", "KP +850"],
  ["+82", "KR +82"],
  ["+965", "KW +965"],
  ["+1", "KY +1"],
  ["+7", "KZ +7"],
  ["+856", "LA +856"],
  ["+961", "LB +961"],
  ["+1", "LC +1"],
  ["+423", "LI +423"],
  ["+94", "LK +94"],
  ["+231", "LR +231"],
  ["+266", "LS +266"],
  ["+370", "LT +370"],
  ["+352", "LU +352"],
  ["+371", "LV +371"],
  ["+218", "LY +218"],
  ["+212", "MA +212"],
  ["+377", "MC +377"],
  ["+373", "MD +373"],
  ["+382", "ME +382"],
  ["+590", "MF +590"],
  ["+261", "MG +261"],
  ["+692", "MH +692"],
  ["+389", "MK +389"],
  ["+223", "ML +223"],
  ["+95", "MM +95"],
  ["+976", "MN +976"],
  ["+853", "MO +853"],
  ["+1", "MP +1"],
  ["+596", "MQ +596"],
  ["+222", "MR +222"],
  ["+1", "MS +1"],
  ["+356", "MT +356"],
  ["+230", "MU +230"],
  ["+960", "MV +960"],
  ["+265", "MW +265"],
  ["+52", "MX +52"],
  ["+60", "MY +60"],
  ["+258", "MZ +258"],
  ["+264", "NA +264"],
  ["+687", "NC +687"],
  ["+227", "NE +227"],
  ["+672", "NF +672"],
  ["+234", "NG +234"],
  ["+505", "NI +505"],
  ["+31", "NL +31"],
  ["+47", "NO +47"],
  ["+977", "NP +977"],
  ["+674", "NR +674"],
  ["+683", "NU +683"],
  ["+64", "NZ +64"],
  ["+968", "OM +968"],
  ["+507", "PA +507"],
  ["+51", "PE +51"],
  ["+689", "PF +689"],
  ["+675", "PG +675"],
  ["+63", "PH +63"],
  ["+92", "PK +92"],
  ["+48", "PL +48"],
  ["+508", "PM +508"],
  ["+1", "PR +1"],
  ["+970", "PS +970"],
  ["+351", "PT +351"],
  ["+680", "PW +680"],
  ["+595", "PY +595"],
  ["+974", "QA +974"],
  ["+262", "RE +262"],
  ["+40", "RO +40"],
  ["+381", "RS +381"],
  ["+7", "RU +7"],
  ["+250", "RW +250"],
  ["+966", "SA +966"],
  ["+677", "SB +677"],
  ["+248", "SC +248"],
  ["+249", "SD +249"],
  ["+46", "SE +46"],
  ["+65", "SG +65"],
  ["+290", "SH +290"],
  ["+386", "SI +386"],
  ["+47", "SJ +47"],
  ["+421", "SK +421"],
  ["+232", "SL +232"],
  ["+378", "SM +378"],
  ["+221", "SN +221"],
  ["+252", "SO +252"],
  ["+597", "SR +597"],
  ["+211", "SS +211"],
  ["+239", "ST +239"],
  ["+503", "SV +503"],
  ["+1", "SX +1"],
  ["+963", "SY +963"],
  ["+268", "SZ +268"],
  ["+1", "TC +1"],
  ["+235", "TD +235"],
  ["+228", "TG +228"],
  ["+66", "TH +66"],
  ["+992", "TJ +992"],
  ["+690", "TK +690"],
  ["+670", "TL +670"],
  ["+993", "TM +993"],
  ["+216", "TN +216"],
  ["+676", "TO +676"],
  ["+90", "TR +90"],
  ["+1", "TT +1"],
  ["+688", "TV +688"],
  ["+886", "TW +886"],
  ["+255", "TZ +255"],
  ["+380", "UA +380"],
  ["+256", "UG +256"],
  ["+1", "US +1"],
  ["+598", "UY +598"],
  ["+998", "UZ +998"],
  ["+39", "VA +39"],
  ["+1", "VC +1"],
  ["+58", "VE +58"],
  ["+1", "VG +1"],
  ["+1", "VI +1"],
  ["+84", "VN +84"],
  ["+678", "VU +678"],
  ["+681", "WF +681"],
  ["+685", "WS +685"],
  ["+383", "XK +383"],
  ["+967", "YE +967"],
  ["+262", "YT +262"],
  ["+27", "ZA +27"],
  ["+260", "ZM +260"],
  ["+263", "ZW +263"]
];
const COUNTRIES = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "American Samoa",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antarctica",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bonaire",
  "Bosnia and Herzegovina",
  "Botswana",
  "Bouvet Island",
  "Brazil",
  "British Indian Ocean Territory",
  "Brunei Darussalam",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde",
  "Cayman Islands",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Christmas Island",
  "Cocos (Keeling) Islands",
  "Colombia",
  "Comoros",
  "Congo",
  "Congo, Democratic Republic",
  "Cook Islands",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Curaçao",
  "Cyprus",
  "Czech Republic",
  "Côte d'Ivoire",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Ethiopia",
  "Falkland Islands",
  "Faroe Islands",
  "Fiji",
  "Finland",
  "France",
  "French Guiana",
  "French Polynesia",
  "French Southern Territories",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Heard Island and McDonald Islands",
  "Holy See",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Isle of Man",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jersey",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Korea, Democratic People's Republic of",
  "Korea, Republic of",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macao",
  "North Macedonia",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "Norfolk Island",
  "Northern Mariana Islands",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Pitcairn",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Romania",
  "Russian Federation",
  "Rwanda",
  "Réunion",
  "Saint Barthélemy",
  "Saint Helena",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Martin",
  "Saint Pierre and Miquelon",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Sint Maarten",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Georgia and the South Sandwich Islands",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Swaziland",
  "Sweden",
  "Switzerland",
  "Syrian Arab Republic",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks and Caicos Islands",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "United States Minor Outlying Islands",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela",
  "Viet Nam",
  "British Virgin Islands",
  "United States Virgin Islands",
  "Wallis and Futuna",
  "Western Sahara",
  "Yemen",
  "Zambia",
  "Zimbabwe"
];

// Export for use in taskpane.js
if (typeof module !== "undefined" && module.exports) {
  module.exports = { PHONE_CODES, COUNTRIES };
}
